import { EmpresaResponse } from '../../../../types/empresa';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import LocationOnIcon from '@mui/icons-material/LocationOn';

interface Props {
    empresa: EmpresaResponse;
}

export function MainContact({ empresa }: Props) {
    return (
        <div className="hidden sm:max-w-[450px] min-[1100px]:flex gap-2 items-center justify-between px-3 sm:min-w-[300px]">
            <div className="flex flex-col">
                <div className="flex gap-2 sm:min-w-[150px]">
                    <Person2RoundedIcon />
                    <p>{empresa.nombreContacto ?? "Sin contacto"}</p>
                </div>
                <div className="flex gap-2 items-center">
                    <EmailRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p>{empresa.correoContacto ?? "Sin correo"}</p>
                </div>
            </div>

            <div className="flex flex-col font-medium w-full">
                <div className="max-[1560px]:justify-center max-[1560px]:flex">
                    <button className="flex gap-2 justify-center">
                        <BusinessRoundedIcon />
                        <p className="max-[1560px]:hidden">{empresa.direccion ?? "Sin dirección"}</p>
                    </button>
                </div>

                <div className="max-[1560px]:justify-center max-[1560px]:flex">
                    <button className="flex gap-2 justify-center">
                        <LocationOnIcon />
                        <p className="max-[1560px]:hidden">Encontrar en el mapa</p>
                    </button>
                </div>
            </div>
        </div>
    );
}